<template>
  <div id="video_page">
    <div class="left_part">
      <div class="left_main">
        <div class="left_tabs" v-if="create_type">
          <div flex-center :class="['tab_item', { 'active': create_form.create_type == 1 }]" @click="changeTab(1)">文生视频
          </div>
          <div flex-center :class="['tab_item', { 'active': create_form.create_type == 2 }]" @click="changeTab(2)">图生视频
          </div>
        </div>
        <div class="tools_introduce">
          <img class="face_icon" src="./img/face.png" alt="">
          <div class="introduce_main">
            <div class="introduce_title">功能介绍</div>
            <div class="introduce_text">在线生成AI视频，图片生成视频，接入火爆全球的 Sora 模型，以及Runway Gen3a_turbo
              、Runway
              Gen 3 影视级动画特效模型
            </div>
          </div>
        </div>
        <lingganTool 
        ref="lingganref"
        :MD5_KEY="'2d8a49bf70b8ddf19ef7f4e6b9244ddf'"
        @createSame="createSame" 
        @use_only="use_only"
        :show_list="['desc','duration','img_urls']" 
        :duration_list="duration_list"
        ></lingganTool>
        <div class="form_wrap">
          <template v-if="create_form.create_type == 2">
            <div class="form_title form_title_other">
              <div class="title_icon"></div>
              <div class="title_text">上传图片</div>
            </div>
            <div class="upload_wrap" v-loading="upImgloading" element-loading-background="rgba(122, 122, 122, 0.8)">
              <el-upload class="img-uploader" :action="fileAPI + '/api/front/aivideo/upload/?soft=1'"
                         :show-file-list="false" :before-upload="beforeUpload" accept=".jpg,.png"
                         :on-success="handleUploadSuccess">
                <div class="upload_inner" flex-center v-if="userInfo.is_vip < 1 || !isLogin">

                  <template v-if="select_rec_img.img_url">
                    <img class="upload_img" :src="cdn_url_replace(tenImg)" alt="">
                    <i @click.stop="deleteImg" class="el-icon-delete"></i>
                  </template>
                  <template v-else>
                    <i class="el-icon-plus"></i>
                    <div class="upload_text"> 将图片拖到此处，或<span style="color: #5865f2;">点击上传</span><br>
                      只能上传jpg/png文件，且不超过10MB
                    </div>
                  </template>
                </div>
                <div class="upload_inner" flex-center v-else>
                  <template v-if="tenImg">
                    <img class="upload_img" :src="cdn_url_replace(tenImg)" alt="">
                    <i @click.stop="deleteImg" class="el-icon-delete"></i>
                  </template>
                  <template v-else>
                    <i class="el-icon-plus"></i>
                    <div class="upload_text"> 将图片拖到此处，或<span style="color: #5865f2;">点击上传</span><br>
                      只能上传jpg/png文件，且不超过10MB
                    </div>
                  </template>
                </div>
              </el-upload>
            </div>
            <div class="tendBox" v-if="create_form.mode != 'Sora2'">
              <div :class="tagAvt == 1 ? 'tendItem tendItemAct' : 'tendItem'" @mouseenter="handleMouseEnter(1)"
                   @mouseleave="handleMouseLeave" @click="tendIt(1)">
                <div class="closeTen" v-show="tenCurent == 1" @click="tenClose(1)">
                  <img src="./img/tagClose.png" alt="">
                </div>
                <!-- <el-image :src="cdn_url_replace(create_form.img_url)" v-show="create_form.img_url"></el-image> -->
                 <img :src="cdn_url_replace(create_form.img_url)" class="tend_img" v-show="create_form.img_url" alt="">
                <div class="null" v-show="!create_form.img_url">
                  <img src="./img/addtag.png" alt="">
                </div>
                首帧图
              </div>
              <div class="tago" @click="changeTend">
                <img src="./img/tago.png" alt="">
              </div>
              <div :class="tagAvt == 2 ? 'tendItem tendItemAct' : 'tendItem'" @mouseenter="handleMouseEnter(2)"
                   @mouseleave="handleMouseLeave" @click="tendIt(2)">
                <div class="closeTen" v-show="tenCurent == 2" @click="tenClose(2)">
                  <img src="./img/tagClose.png" alt="">
                </div>
                <!-- <el-image :src="cdn_url_replace(create_form.img_urls)" v-show="create_form.img_urls"></el-image> -->
                 <img :src="cdn_url_replace(create_form.img_urls)" class="tend_img" v-show="create_form.img_urls" alt="">
                <div class="null" v-show="!create_form.img_urls">
                  <img src="./img/addtag.png" alt="">
                </div>
                尾帧图
              </div>
            </div>
            <div class="frame" v-if="create_form.create_type == 2 && create_form.mode == 'Runway3'">
              <span>
                以图片作为结尾帧
              </span>
              <div>
                <el-switch v-model="frame">
                </el-switch>
              </div>
            </div>
          </template>
          <div
              v-if="create_form.create_type == 1 ? true : create_form.create_type == 2 && create_form.mode == 'gen3a_turbo' ? false : true">
            <div class="form_title">
              <div class="title_icon"></div>
              <div class="title_text">
                描述你的视频场景
                <!-- <div :class="create_form.desc.trim().length?'tishici tishici_act':'tishici'" @click="showTishici">优化提示词</div> -->
              </div>
            </div>
            <div class="desc_box" id="only_desc" v-if="userInfo.is_vip == 1||video_list.length!=0">
              <el-input :input-style="{ minHeight: '31px' }" :rows="4" v-model="create_form.desc" type="textarea"
                        placeholder="请输入创意描述，包含内容主体+动作/场景，一键生成"/>
              <div class="desc_box_bottom">
                <!-- <div v-if="!create_form.desc.trim().length"></div> -->
                <div class="bottom_left" bottom_left @click="showTishici">
                  <!-- <el-switch v-model="auto_spell"
                             @change="getPromptData4()"
                             active-value="1"
                             inactive-value="0"
                             active-color="#5865F2"
                             inactive-color="#ffffff2d">
                  </el-switch> -->
                  <div>
                    <img src="@/components/images/lingganImg/ai_tishi.png" class="ai_tishi_img" alt=""> 
                    Ai优化提示词（免费）</div>
                </div>
                <div class="cleat_desc_btn" @click="create_form.desc = ''">清空</div>
              </div>
            </div>
            <el-popover v-else ref="descPopover" trigger="click" placement="bottom-start" :width="320"
                        :visible-arrow="false" popper-class="desc_area_popup">
              <div class="desc_popover">
                <div class="desc_popover_top">
                  <span style="color:#FF990E;font-weight:700;">免费体验</span> 以下示例
                </div>
                <ul class="recommend_list">
                  <li v-for="rec in sampleSelectList" @click="choose_tips_item(rec)">
                    <img class="rec_img" :src="cdn_url_replace(rec.cover_url)" alt="">
                    <div class="rec_text">
                      <div class="rec_title">{{ rec.text_prompt_cn }}</div>
                      <div class="rec_desc">{{ rec.text_prompt }}</div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="desc_box" slot="reference">
                <el-input :input-style="{ minHeight: '31px' }" :rows="4"
                          v-model="create_form.desc" type="textarea"
                          placeholder="请输入创意描述，包含内容主体+动作/场景，一键生成"/>
                <div class="desc_box_bottom">
                  <!-- <div v-if="!create_form.desc.trim().length"></div> -->
                  <div class="bottom_left" bottom_left @click="showTishici">
                    <!-- <el-switch v-model="auto_spell"
                               active-value="1"
                               inactive-value="0"
                               active-color="#5865F2"
                               inactive-color="#ffffff2d"></el-switch> -->
                    <div>
                      <img src="@/components/images/lingganImg/ai_tishi.png" class="ai_tishi_img" alt=""> 
                      Ai优化提示词（免费）</div>
                  </div>
                  <div class="cleat_desc_btn" @click="create_form.desc = ''">清空</div>
                </div>
              </div>
            </el-popover>
          </div>

          <div class="form_title">
            <div class="title_icon"></div>
            <div class="title_text">选择模型</div>
          </div>
          <div class="model_wrap">
            <div @click="selectModel(model, index)" v-if="index != 1"
                 :class="['model_item', 'select_item', { 'active': create_form.mode == model.name2 }]" flex-center
                 v-for="(model, index) in platform_list">{{ model.name }}
              <div class="need_vip" v-if="model.need_vip">VIP
              </div>
            </div>
          </div>
          <div class="model_desc" v-if="create_form.mode != 'Sora2'">{{ model_desc }}</div>

          <div>

          </div>
          <div>
            <div class="form_title">
              <div class="title_icon"></div>
              <div class="title_text">{{ create_form.mode == 'Sora2' ? '视频比例' : '视频时长' }}</div>
            </div>
            <div class="model_wrap" v-if="create_form.mode != 'Sora2'">
              <div @click="selectTimer(du)"
                   :class="['model_item', 'select_item', { 'active': create_form.duration == du.value }]" flex-center
                   v-for="du in duration_list">{{ du.name }}
                <div class="need_vip" v-if="du.need_vip">VIP</div>
              </div>
            </div>

            <div class="video_size_list" v-show="create_form.mode == 'Sora2'">
              <div :class="['sise_item',{'active':video_size==item.value}]" v-for="item in size_list" :key="item.value" @click="selectSize(item)">
                <img :src="cdn_url_replace(item.url)" alt="" class="size_img">
                {{ item.name }}
              </div>
          </div>
          </div>

        </div>
      </div>
      <!--       <div class="left_footer">
              <div :class="['primary_button', { 'disabled_btn': create_form.mode == 'Sora' }]" @click="clickSubmit"
                v-loading="sendLoading">
                {{ create_form.mode == 'Sora' ? '敬请期待' : '提交任务' }}
                <span class="fz12" v-if="create_form.mode != 'Sora'">（消耗{{ scoreCode }}积分）</span>
              </div>
            </div> -->
      <div class="newSubList">
        <div class="newSumit newSumitOthers" v-show="create_form.mode == 'Sora2'" @click="clickSubmit">
          提交任务（消耗10积分）
        </div>
        <div class="newSumitList">
          <div class="newSumit" @click="clickSubmit" v-show="create_form.mode != 'Sora2'">
            生成标清
            <div class="subText">（消耗{{ scoreCode }}积分）</div>
          </div>
          <div class="newSumit newSumitOther" @click="create_form.is_hd=1,clickSubmit()"
               v-show="create_form.mode != 'Sora2'">
            生成高清
            <div class="subText">（消耗{{ newscoreCode }}积分）</div>
            <img src="./img/img_icon_hot01.gif" class="subImg" alt="">
          </div>
        </div>
        <div class="screen">
          内容由 Ai 生成，请仔细甄别
        </div>
      </div>
    </div>
    <div class="main_part">
      <div class="top_tips">
        <span class="one">#</span><span class="two">创作中心</span><span
          class="three">请遵守中华人民共和国网络安全法，严禁生成涉及政治人物，色情、恐怖等不良内容，
          如有违规封号处理</span>
      </div>
      <div class="create_center" ref="scrollWrap" @scroll="testScroll">
        <!--样例开始-->
        <div class="message_list"
             v-infinite-scroll="fettchSampleList"
             :infinite-scroll-immediate="false"
             :infinite-scroll-disabled="SampleListDisabled"
             v-if="!isLogin || video_list.length == 0">
          <div class="list_item" v-for="(msg, index) in sampleSysList">
            <div class="item">
              <div class="item_touxiang">
                <img src="./img/modle_icon/runway.png" class="avatar"/>
              </div>
              <div class="item_right">
                <div class="item_top">
                  <div class="top_left">
                    <div style="font-size: 14px">
                      Runway
                    </div>
                    <template>
                      <div class="item_type">
                        示例
                      </div>
                    </template>
                    <div class="item_time">{{ msg.add_time }}</div>
                  </div>
                  <div class="top_right">
                    <div @click="sample_btn('del')">
                      <i class="el-icon-delete"></i>删除
                    </div>
                    <div style="margin-left: 5px" @click="sample_btn('noDown')">
                      <i class="el-icon-download" style="font-size: 14px;"></i>下载
                    </div>
                    <div style="margin-left: 5px" @click="sample_btn('put')">
                      <i class="el-icon-position"></i> 推荐广场
                    </div>
                  </div>
                </div>
                <div class="msg_text" v-if="msg.text_prompt_cn">{{ msg.text_prompt_cn }}</div>
                <template v-if="msg.text_prompt">
                  <div class="split_line"></div>
                  <div class="msg_text msg_desc">{{ msg.text_prompt }}</div>
                </template>
                <div class="video_wrap"
                     @click.stop="handlePlay('play',index,msg)">
                  <div class="creating" v-if="msg.status === 1">
                    <template>
                      <img class="loading_gif" src="./img/loading-new.gif">
                      <div class="loading_text"><span>生成视频需要极大的计算量，请耐心等待...</span> <span
                          v-if="msg.progress > 10">{{
                          msg.progress
                        }}%</span></div>
                    </template>
                  </div>
                  <video controls controlslist="nodownload" v-else style="width: 665px;height: 400px"
                         :poster="msg.cover_url" preload="none"
                         v-loading="true" :src="msg.video_url"
                         @play="handlePlay('',index)"
                         :ref="`videoPlayer${index}`"></video>
                  <div class="tozan">
                    <div class="zanOne" @click="tozanFn(msg,index)" v-show="!msg.is_vote">
                      <img src="./img/zan1.png" class="zanImg"/> 赞一下
                    </div>
                    <div class="zanDetail" v-show="msg.is_vote">
                      <div class="zanOne zanTwo">
                        <img src="./img/zan2.png" class="zanImg"/> 已赞过
                      </div>
                    </div>
                    <div class="zanTex">
                      此作品已获得{{ msg.votes }}个赞
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--样例结束-->

        <!--        <div class="message_list" v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="noMore || loading">-->
        <div class="message_list"
             v-infinite-scroll="loadMore"
             :infinite-scroll-immediate="false"
             :infinite-scroll-disabled="noMore">
          <div class="list_item" v-for="(msg, index) in video_list">
            <div class="item">
              <div class="item_touxiang">
                <img src="./img/modle_icon/runway.png" class="avatar"/>
              </div>
              <div class="item_right">
                <div class="item_top">
                  <div class="top_left">
                    <div style="font-size: 14px">
                      Runway
                    </div>
                    <template>
                      <div class="item_type">
                        {{ msg.img_url == "" ? '文生视频' : '图生视频' }}
                      </div>
                    </template>
                    <div class="item_time">{{ msg.add_time }}</div>
                  </div>
                  <div class="top_right">

                    <div  style="margin-left: 5px" @click="deleteVideo(index, msg)">
                      <i class="el-icon-delete"></i>删除
                    </div>
                    <div style="margin-left: 5px" @click="downloadVideo( msg,index)">
                      <i class="el-icon-download" style="font-size: 14px;"></i>下载
                    </div>
                    <div v-if="msg.status == 2">
                      <div style="margin-left: 5px" v-if="msg.is_public == 0 || msg.is_public == null"
                           @click="recommend(msg.id, index)">
                        <i class="el-icon-position"></i> 推荐广场
                      </div>
                      <div style="margin-left: 5px" v-else>
                        <i class="el-icon-position"></i> 已推荐到广场
                      </div>
                    </div>
                  </div>
                </div>
                <div class="msg_text" v-if="msg.text_prompt_cn">{{ msg.text_prompt_cn }}</div>
                <template v-if="msg.text_prompt">
                  <div class="split_line"></div>
                  <div class="msg_text msg_desc">{{ msg.text_prompt }}</div>
                </template>
                <div class="video_wrap">
                  <div v-if="msg.status == 0">
                    <div class="creating">
                      <template v-if="msg.progress > 10">
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="progress">正在为您生成··· {{ msg.progress }}%</div>
                      </template>
                      <template v-else>
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                      </template>
                    </div>
                  </div>
                  <div v-if="msg.status == 1">
                    <div class="creating">
                      <template v-if="msg.progress > 10">
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="progress">正在为您生成··· {{ msg.progress }}%</div>
                      </template>
                      <template v-else>
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                      </template>
                    </div>
                  </div>

                  <div v-if="msg.status == 2 && msg.local_video_url === null">
                    <div class="creating">
                      <template v-if="msg.progress != 0">
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="progress">正在为您生成··· {{ msg.progress }}%</div>
                      </template>
                      <template v-else>
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                      </template>
                    </div>
                  </div>
                  <div v-if="msg.status == 2 && msg.local_video_url !== null" class="success_shou">
                    <div class="success_shouVideo"
                         @click.stop="onVideoPlay('play',index,msg)">
                      <video role="application" controls
                             controlslist="nodownload"
                             :poster="msg.cover_url != null ? msg.cover_url : ''"
                             :preload="msg.cover_url != null ? 'none' : 'auto'" v-loading="true"
                             :src="msg.local_video_url"
                             :ref="`videoPlayers${index}`"
                             @play="onVideoPlay('',index)"></video>
                      <div v-if="msg.img_url != null || msg.img_url != ''" class="success_img"
                           :style="msg.img_url == null || msg.img_url == '' ? 'display:none;' : 'display:;'">
                        <!--                        <img :src="msg.img_url" @error="handleImageError(index)"  alt="" class="xianshi" >-->
                        <img :src="msg.img_url" alt="" class="xianshi">
                        <div class="success_imgdel">
                          <div style="display: flex;align-items: flex-end;">
                            <span
                                style="background: #5865f2a8;border-radius: 3px;margin:  2px;padding: 0 4px;color: white">原图</span>
                          </div>
                          <div style="display: flex;flex-direction: column;padding: 2px 2px 0 0 ;">
                            <i class="el-icon-close yichang" @click="msg.img_url = ''"></i>
                          </div>
                        </div>
                      </div>
                      <div :style="msg.img_url == null || msg.img_url == '' ? 'display:none;' : 'display:;'"
                           style="position: absolute;top: 2px;left: 0;">
                        <span
                            style="z-index: 10;  background: #5865f2a8;border-radius: 3px;margin: 2px;padding: 3px 4px;color: white">生成后</span>
                      </div>
                    </div>
                  </div>
                  <div class="error_video" v-loading="msg.regenLoading > 0"
                       v-if="(msg.status == 3) && (msg.retry_num < 3 && msg.is_retry == 0)">
                    <!-- 绘画 失败 -->
                    <img class="error_icon" src="./img/image_error.png" alt="">
                    <div class="error_text">很遗憾，生成失败 !</div>
                    <!--                    <div class="error_text">很遗憾，生成失败 !</div>-->
                    <div class="error_text2" @click="regenerate(msg, index)">点此重新生成</div>
                    <div class="error_text3">（成功率在90%以上）</div>
                    <div class="error_text4" v-if="msg.show_error">
                      失败原因： <span style="color:red;">{{ msg.show_error }}</span>
                    </div>
                    <div class="error_text4" v-else>
                      <span>涉政、涉黄等请勿提交，会封号其他问题，请联系</span>
                      <a
                          :href="kefu_url"
                          target="_blank">在线客服</a>
                    </div>
                  </div>
                  <div class="error_video create_error_old"
                       v-else-if="(msg.status == 3) && (msg.retry_num >= 3 || msg.is_retry != 0)">
                    <!-- 绘画 失败 -->
                    <img class="error_icon" src="./img/image_error.png" alt="">
                    <div class="error_text">很遗憾，生成失败 !</div>
                    <div class="error_btn" @click="showDefeatPopup()">查看失败原因</div>
                    <div class="error_text3">（成功率在90%以上）</div>
                    <div class="error_text4">涉政、涉黄等请勿提交，会封号其他问题，请联系<a
                        :href="kefu_url"
                        target="_blank">在线客服</a>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <el-dialog :visible.sync="imgDialogVisible" custom-class="is-align-center csd-dialog" width="474px"
               :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="recommend_dialog">
        <i class="el-icon-error" @click="imgDialogVisible = false"></i>
        <div class="dialog_title">上传图片</div>
        <div class="dialog_body">
          <div class="body_title">
            <div class="title_icon"></div>
            <div class="title_text">从模版中选择图片</div>
          </div>
          <div class="img_wrap">
            <div :class="['img_item', { 'active': select_rec_img.img_url == img.img_url }]"
                 @click="select_rec_img = img" v-for="img in rec_img_list">
              <img class="rec_img" :src="img.img_url" alt="">
              <div class="img_name" flex-center>{{ img.name }}</div>
            </div>
          </div>
          <div class="upload_tips">
            <i class="el-icon-link"></i> 或上传参考图像生成视频 <span class="vip_tag">VIP</span>
          </div>
          <div class="upload_wrap">
            <!-- <el-upload class="img-uploader"> -->
            <div class="result_wrap" flex-center @click.stop="goUploadImg">
              <div v-if="select_rec_img.img_url" class="show_img" flex-center>
                <img class="select_img" :src="select_rec_img.img_url" alt="">
                <i @click.stop="select_rec_img = { img_url: '' }" class="el-icon-delete"></i>
              </div>


              <div class="no_img" flex-center v-else>
                <el-upload class="upload-demo" drag :action="fileApi + '/api/front/aivideo/upload/?soft=1'"
                           :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                           multiple>
                  <div class="upload_icon">+</div>
                  <div class="upload_text">点击上传图片</div>
                </el-upload>
              </div>
            </div>
            <!-- </el-upload> -->
          </div>
          <div flex-center class="dialog_footer">
            <div class="gray_button footer_btn" @click='imgDialogVisible = false'> 取消</div>
            <div class="primary_button footer_btn" @click="imgDialogVisible = false"> 提交</div>
          </div>
        </div>
      </div>
    </el-dialog>

    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
    <shibaiyuanyin ref="retryPop"></shibaiyuanyin>

    <!-- ai提示词 -->
    <AIpromptWords
        :typedata="'Runway Gen3a_turbo、Runway Gen'"
        :inpdata="create_form.desc"
        @getPromptData1="getPromptData2"
        ref="promptBox"/>
  </div>

</template>
<script type="text/ecmascript-6">

import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import shibaiyuanyin from "COMPONENTS/shibaiyuanyin.vue";
import AIpromptWords from "COMPONENTS/AIpromptWords.vue";
import lingganTool from "COMPONENTS/lingganTool.vue";
import utils from '../../utils'
import AliCdn from '../../utils/ali_cdn'


export default {
  components: {faceVerifyPopup, shibaiyuanyin, AIpromptWords, lingganTool},
  data() {
    return {
      kefu_url:SITE_BTN_CONFIG.kefu_url.btn_value,
      scoreCode: 25,
      create_form: {
        create_type: 1,
        img_url: "",//普通
        desc: "",
        auto_optimize: false,
        style: 0,
        size: '1:1',
        duration: 5,
        soft: 1,
        aspect_ratio: 6,
        mode: 'gen3a',
        img_urls: "",//以图片作为结尾帧
        seconds: 5,// 默认视频时长
        exploreMode: false, //true探索模式 false积分模式
        is_hd: 0,// 清晰度
      },
      tenImg: '',
      fileApi: FILE_API_SERVER,
      frame: false,
      fileAPI: API_SERVER,
      imgDialogVisible: false,
      model_desc: 'Runway Gen 3 影视级动画特效，生成效果较好',
      platform_list: [
        {name: "Runway3", name2: "gen3a", need_vip: 1, desc: 'Runway Gen 3 影视级动画特效，生成效果较好', platform: 1},
        {
          name: "Turbo",
          name2: "gen3a_turbo",
          need_vip: 1,
          desc: 'Runway Gen 2 影视级动画特效，生成效果较好',
          platform: 1
        },

        // {
        //   name: "Sora2",
        //   name2: "Sora2",
        //   need_vip: 1,
        //   desc: '即将开放OpenAI-Sora大师级模型，长达60秒巨作',
        //   platform: 3
        // },
      ],
      style_list: [
        {type: 1, name: "真实", id: 0},
        {type: 2, name: "动漫", id: 4},
        {type: 3, name: "卡通", id: 6},
      ],
      exploreMode_list: [
        {value: true, name: "排队",},
        {value: false, name: "不排队",},
      ],

      video_list: [],
      noMore: true,

      page: 1,
      intervalId: null,
      rec_img_list: [
        {
          name: '欧美女神',
          img_url: 'http://gips3.baidu.com/it/u=3886271102,3123389489&fm=3028&app=3028&f=JPEG&fmt=auto?w=1280&h=960'
        },
        {
          name: '女生写真',
          img_url: 'http://gips1.baidu.com/it/u=1746086795,2510875842&fm=3028&app=3028&f=JPEG&fmt=auto?w=1024&h=1024'
        }, {
          name: '守望星空',
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/03.webp'
        }, {
          name: "皮克斯风",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/04.jpg'
        }, {
          name: "日漫女生",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/05.jpg'
        }, {
          name: "女生跳舞",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/06.jpg'
        }, {
          name: "孤独侠客",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/07.webp'
        }, {
          name: "美女骑行",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/08.webp'
        }, {
          name: "丛林狐狸",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/09.webp'
        }, {
          name: "饥饿雄狮",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/10.webp'
        }, {
          name: "旋转场景",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/11.webp'
        }, {
          name: "沙漠蜥蜴",
          img_url: 'https://wenku202404.oss-cn-beijing.aliyuncs.com/runaway/img/12.webp'
        }
      ],
      select_rec_img: {
        img_url: ''
      },
      cdnOptions: {
        cdnDomain: "cdnmjimg2024.m.nengshuohuihua.com"
      },
      timer: null,
      max_mj_id: 0,
      checkIds: [],
      sendLoading: false,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleSelectList: [], // 选择样例
      sampleTimer: null,
      success_icon: true,
      tenCurent: 0,
      tagAvt: 1,
      definition: [
        {name: '标清', value: 0},
        {name: '高清', value: 1},
      ],
      upImgloading: false,
      zanID: 0,
      isZan: false,
      votes: 0,
      auto_spell: '1',
      perIncan: false, // ai提示词是否返回
      newscoreCode: 35,
      isTips: false,
      SampleListDisabled: true,
      size_list: [
        {name: '16:9', value: '16:9',url:require('./img/16^9.png')},
        {name: '9:16', value: '9:16',url:require('./img/9^16.png')},
      ],
      video_size: '16:9',
    }

  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    create_type() {
      this.create_form.create_type = this.$store.state.video_type || 1;
      return this.$store.state.video_type || 1;
    },
    duration_list() {
      if (this.create_form.mode == 'gen2') {
        this.create_form.duration = 4
        return [{name: '4秒', need_vip: 0, value: 4}]
      } else if (this.create_form.mode == 'gen3a') {
        this.create_form.duration = 5
        return [{name: '5秒', need_vip: 1, value: 5}, {name: '10秒', need_vip: 1, value: 10}]
      } else {
        this.create_form.duration = 5
        return [{name: '5秒', need_vip: 1, value: 5}, {name: '10秒', need_vip: 1, value: 10}]
      }
    }
  },
  created() {
    this.sampleUserList = JSON.parse(localStorage.getItem('sampleUserVideoList') || "[]")
    this.fetchVideoList()
    // this.fettchSampleList()

    this.debouncedFetchData = this.debounce((data) => this.checkZan(data), 300)
    this.debouncedOutData = this.debounce((data) => this.outZan(data), 300)

  },
  mounted() {
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null
    }

  },
  methods: {
    //单一功能赋值
    use_only(data){
      console.log(data);
      
      if(data.data.img_urls){
        this.create_form.create_type = 2
      }else{
        this.create_form.create_type = 1
      }
      if(data.type == 'duration'){
        this.create_form.duration = data.data.duration
      }else if(data.type == 'desc'){
        this.create_form.desc = data.data.desc
      }else if(data.type == 'size'){
        this.create_form.video_size = data.data.value
      }else if(data.type == 0){
        this.create_form.img_url = data.data.img_url
        this.select_rec_img.img_url = data.data.img_url
        this.tenImg = data.data.img_url
      }else if(data.type == 1){
        this.create_form.img_urls = data.data.img_urls
        this.select_rec_img.img_url = data.data.img_urls
        this.tenImg = data.data.img_urls
      }
    },
    // 创建同款
    createSame(data){
    console.log(data);
    
      this.create_form.desc = data.desc
      if(data.img_url){
        this.changeTab(2)
      }
      this.create_form.img_url = ''
      this.create_form.img_urls = ''
      this.select_rec_img.img_url = ''
      this.tenImg = ''
      this.create_form.duration = data.duration
      this.tagAvt = 1
      if(data.img_url){
        this.create_form.img_url = data.img_url
        this.select_rec_img.img_url = data.img_url
        this.tenImg = data.img_url
        this.tagAvt = 1
      }else{
        this.create_form.create_type = 1
      }
      if(data.img_urls){
        this.create_form.img_urls = data.img_urls
        this.select_rec_img.img_url = data.img_urls
        this.tenImg = data.img_urls
        this.tagAvt = 2
        this.create_form.create_type = 2
      }
      this.create_form.id = data.id
      this.create_form.md5_key = utils.setMd5Key(data.id)
      this.setScore()
    },
    cdn_url_replace(url, o_url, c_url){
      if (!c_url){
        c_url = 'https://cdnmjimgnas.m.nengshuohuihua.com'
      }
      if (!o_url){
        o_url = 'https://mjimg.zhanjuzhe.cn'
      }
      if (url.indexOf('https://mjimg2024.oss-cn-beijing.aliyuncs.com') > -1){
        return AliCdn.signUrl(url, this.cdnOptions)
      }
      if (url.indexOf('https://zjzai20251109.oss-cn-hangzhou.aliyuncs.com') > -1){
        return AliCdn.signUrl(url, {
          cdnDomain: "cdnzjzai.m.nengshuohuihua.com"
        })
      }
      return url.replace(o_url, c_url)
    },
    selectSize(item){
      this.video_size = item.name
    },
    testScroll() {
      // console.log('滚动');
      utils.setScrollDoc()
    },
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },

    setScore() {
      if (this.create_form.create_type == 1) {
        console.log('文生视频')
        if (this.create_form.duration == 5 && this.create_form.is_hd == 0) {
          this.scoreCode = 25
          this.newscoreCode = 35
        } else if (this.create_form.duration == 10 && this.create_form.is_hd == 0) {
          this.scoreCode = 50
          this.newscoreCode = 70
        } else if (this.create_form.duration == 5 && this.create_form.is_hd == 1) {
          this.newscoreCode = 35
        } else if (this.create_form.duration == 10 && this.create_form.is_hd == 1) {
          this.newscoreCode = 70
        }
      } else {
        // console.log('图省事视频')
        if (!this.create_form.img_urls) {
          if (this.create_form.duration == 5 && this.create_form.is_hd == 0) {
            this.scoreCode = 25
            this.newscoreCode = 35
          } else if (this.create_form.duration == 10 && this.create_form.is_hd == 0) {
            this.scoreCode = 50
            this.newscoreCode = 70
          } else if (this.create_form.duration == 5 && this.create_form.is_hd == 1) {
            this.newscoreCode = 35
          } else if (this.create_form.duration == 10 && this.create_form.is_hd == 1) {
            this.newscoreCode = 70
          }
        } else {
          this.scoreCode = 50
        }

      }

    },
    changeTab(data) {
      this.create_form.create_type = data
      this.create_form.is_hd = 0
      if (data == 1) {
        this.definition = [{name: '标清', value: 0},
          {name: '高清', value: 1},]
        this.setScore()
      } else {
        if (this.create_form.img_urls) {
          this.create_form.is_hd = 0
          this.definition = [{name: '高清', value: 0},]
          if (this.create_form.duration == 5) {
            this.setScore()
          }
        } else {
          this.definition = [{name: '标清', value: 0}, {name: '高清', value: 1},]

        }
        this.setScore()
      }
    },
    deleteImg() {
      if (this.tagAvt == 2) {
        this.definition = [{name: '标清', value: 0}, {name: '高清', value: 1},]
        this.create_form.is_hd = 0
        this.create_form.img_urls = ''
        this.setScore()
      } else {
        this.create_form.img_url = ''
      }
      this.tenImg = ''
      this.select_rec_img.img_url = ''
    },
    tenClose(data) {
      if (data == 2) {
        this.definition = [{name: '标清', value: 0}, {name: '高清', value: 1},]
        this.create_form.is_hd = 0
        this.create_form.img_urls = ''
        this.setScore()
      } else {
        this.create_form.img_url = ''
      }
      this.select_rec_img.img_url = ''
    },
    tendIt(data) {
      this.tagAvt = data
      this.tenImg = data == 1 ? this.create_form.img_url : this.create_form.img_urls
      this.select_rec_img.img_url = this.tenImg
      if (this.create_form.img_urls && this.create_form.img_url == '') {
        this.setScore()
      }
    },
    handleMouseEnter(data) {

      this.tenCurent = data
    },
    handleMouseLeave() {
      this.tenCurent = 0
    },
    changeTend() {
      if (this.create_form.img_url && this.create_form.img_urls == '') {
        this.definition = [{name: '高清', value: 0},]
        this.create_form.is_hd = 0
        let par = this.create_form.img_url
        this.create_form.img_urls = par
        this.create_form.img_url = ''
        this.setScore()
      } else if (this.create_form.img_urls && this.create_form.img_url == '') {
        this.definition = [{name: '标清', value: 0},
          {name: '高清', value: 1},]
        this.create_form.is_hd = 0
        let par = this.create_form.img_urls
        this.create_form.img_url = par
        this.create_form.img_urls = ''
        this.setScore()
      } else {
        let par = this.create_form.img_url
        this.create_form.img_url = this.create_form.img_urls
        this.create_form.img_urls = par
      }
      this.tenImg = this.tagAvt == 1 ? this.create_form.img_url : this.create_form.img_urls
    },
    getProfile() {
      let invite_code = localStorage.getItem("invite_code") || "";
      this.$http.get(`/front/user/profile/`, {
        params: {
          invite_code: invite_code,
          app_id: APP_ID
        }
      }).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setShowLogin', false)
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          localStorage.setItem("invite_code", res.data.invite_code);
        }
      }).finally(() => {

      })
    },
    scrollToTop() {
      this.$nextTick(() => {
        let scrollWrap = this.$refs.scrollWrap;
        scrollWrap.scrollTop = 0;
      })
    },
    fettchSampleList() {
      this.SampleListDisabled = true
      // 获取样例数据
      this.$http.get('/front/aivideo/sample/?soft=1', {
        params: {
          page: this.page,
          size: 5,
        }
      }).then((res) => {
        this.page++
        this.SampleListDisabled = false
        if (res.data.item_list.length < 5) {
          this.SampleListDisabled = true
          this.$message.warning('样例已全部加载')
        }
        this.sampleSysList = this.sampleSysList.concat(res.data.item_list)
        this.sampleSelectList = res.data.item_list
      })
    },

    choose_tips_item(item) {
      // 样例 选中
      if (!this.checkLogin()) {
        return
      }
      let _item = {...item}
      _item.progress = 0
      this.sampleSysList.unshift(_item)

      this.sampleUserList.unshift(item)
      localStorage.setItem("sampleUserVideoList", JSON.stringify(this.sampleUserList))
      if (this.sampleTimer != null) {
        // this.scrollToTop()
        return
      }
      this.sampleTimer = setInterval(() => {
        let createNum = 0; // 需要生成个数
        this.sampleSysList.forEach(e => {
          if (e.progress < 100) {
            createNum += 1
            let num = parseInt(Math.random() * 10);
            if (e.progress + num > 100) {
              e.progress = 99
              // this.scrollToTop()
            } else {
              e.progress += num
            }
          }
        })
        if (createNum == 0) {
          clearInterval(this.sampleTimer)
          this.sampleTimer = null
          // this.scrollToTop()
        }
      }, 500)
    },
    fetchVideoList() {
      this.$http.get(`/front/aivideo/user/video/`, {
        params: {
          max_mj_id: this.max_mj_id,
          soft:this.create_form.mode == 'Sora2' ? 8 : 1,
        }
      }).then(res => {
        if (res.status == '200') {
          this.noMore = false
          if (res.data.item_list.length > 0) {
            if (this.max_mj_id == 0) {
              res.data.item_list.forEach(e => {
                if (e.status <= 1 || (e.status == 2 && !e.local_video_url)) {
                  this.checkIds.push(e.id)
                }
              })
              this.fetchMsg()
            }
            this.max_mj_id = res.data.item_list[res.data.item_list.length - 1].id
            this.video_list = this.video_list.concat(res.data.item_list)

            this.video_list.forEach(item => {
              item.img_url.length == 0 ? item.img_url = '' : item.img_url
              if (item.regenLoading != 1) {
                item.regenLoading = 0
              }
            })


          } else {
            this.noMore = true
            if (this.max_mj_id == 0) {
              this.fettchSampleList()
            }
          }
        } else {
          this.fettchSampleList()
        }
      }).finally(() => {

      })
    },
    fetchMsg() {
      if (this.checkIds.length === 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null
      }
      this.timer = setInterval(() => {
        this.$http.post('/front/aivideo/check/', {ids: this.checkIds}).then((res) => {
          if (res.status === "200") {
            let item_list = res.data.item_list;
            let _id = 0;
            item_list.forEach(e => {
              _id = e.id

              if (e.status == 3 && e.error_message == '服务异常,请联系客服') {
                this.$confirm("服务异常,请联系客服", '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {

                }).catch(() => {

                });
                this.checkIds = this.checkIds.filter(i => i !== _id)
                this.video_list.forEach((item, index,) => {
                  if (item.id == _id) {
                    item.status = 3
                  }
                })

              } else if (e.status == 3 && e.error_message == '任务提交失败，请重试！') {
                this.$confirm("生成异常，已为您重新排队", '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {

                }).catch(() => {

                });
                this.create_form.desc = e.text_prompt_cn
                this.create_form.img_url = e.img_url
                this.create_form.mode = e.mode
                this.create_form.seconds = e.seconds
                this.create_form.style = e.style
                this.create_form.duration = e.seconds
                // this.create_form.exploreMode = e.exploreMode== 1? true:false

                this.checkIds = this.checkIds.filter(i => i !== _id)
                this.video_list.forEach((item, index,) => {
                  if (item.id == _id) {
                    item.status = 3
                  }
                })
                this.clickSubmit()
              } else if (e.status == 3 && e.show_error_message) {
                this.$message.error(e.error_message)
              }

              let item = this.video_list.filter((obj) => obj.id === _id)[0];
              item.status = e.status
              item.is_public = 0
              item.img_url = e.img_url
              // item.progress = e.progress
              let num = parseInt(Math.random() * 10);
              if (item.progress + num > 100) {
                item.progress = 99
              } else {
                item.progress += num
              }
              if (e.status > 2) {
                // 删除生成成功或失败的
                this.checkIds = this.checkIds.filter(i => i !== _id)

              }
              if (e.status == 2 && e.local_video_url != null) {
                // 生成成功 并下载本地
                this.checkIds = this.checkIds.filter(i => i !== _id)
                // 生成成功 并下载本地
                item.local_video_url = e.local_video_url
                item.cover_url = e.cover_url
                item.img_url = e.img_url
                item.text_prompt = e.text_prompt
                item.regenLoading = 0
                item.progress = 100
                // 创作成功检测是否弹出挽留弹窗
                utils.checkContinuePop(this.$store.state.userInfo)
              }
              if (e.status === 3) {
                // 失败
                item.show_error = e.show_error
                if (e.show_error) {
                  this.$message.error(e.show_error)
                }
                this.video_list.forEach((_list, num) => {
                  if (_list.id == e.id) {
                    this.video_list[num] = e
                  }
                })
              }
            })
          }
          if (this.checkIds.length === 0) {
            clearInterval(this.timer);
          }else{
            clearInterval(this.timer);
            this.fetchMsg()
          }
        }).catch((res) => {
          clearInterval(this.timer);
        })
      }, 5000)
    },
    showTishici(){
      if(this.$refs.lingganref){
        this.$refs.lingganref.visible = false
        this.$refs.lingganref.show_detail_popup = false
      }
      if(document.querySelector('.autoMatic_box')){
        this.$refs.promptBox.show(false)
      }else{
        if (!this.isLogin) {
          this.$message.warning('请先登录！')
          return
        }
        if(!this.create_form.desc.trim().length){
          this.$message.warning('请输入创意描述！')
          return 
        }
        this.$refs.promptBox.show(true)
      }
    },
    clickSubmit() {
      if (!this.checkLogin()) {
        return
      }
      if(SITE_BTN_CONFIG.bnt_runway_create.btn_state==0){
        if(this.userInfo.is_vip==0){
          utils.createErrTip('no_open_vip')
        }else{
          if(this.userInfo.is_vip_end==1){
            utils.createErrTip('vip_expire')
          }else{
            this.$store.commit('setTechnical_Show',true)
          }
        }
        return;
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        })
        return false
      }
      // if (this.userInfo.is_vip == 0 || this.userInfo.is_vip_end == 1) {
      //   this.$store.commit('setToastVip', true);
      // }
      this.create_form.name = this.create_form.desc
      this.create_form.text_prompt = this.create_form.desc
      if (this.create_form.create_type === 2 && this.create_form.mode == 'gen3a_turbo') {
        this.create_form.text_prompt = ""
      } else {
        if (this.create_form.text_prompt.trim() === "") {
          this.$message.warning('请输入描述')
          return
        }
      }
      if (this.create_form.text_prompt.length > 500) {
        this.$message.warning('描述信息不能超过500字符')
        return
      }


      if (this.create_form.create_type === 1) {
        this.create_form.img_url = ""
      }
      if (this.sendLoading) {
        this.$message.warning('正在提交任务！')
        return
      }
      if (this.create_form.create_type === 2) {
        if (this.create_form.img_urls && this.create_form.duration == 10) {
          this.$message.warning('添加尾帧图仅支持生成5s的视频')
          return
        }
        if (this.create_form.img_url == '') {
          this.$message.warning('请添加首帧图')
          return;
        }
        if (this.create_form.mode == 'Runway3' && this.frame == true) {
          this.create_form.img_urls = this.select_rec_img.img_url
          //this.create_form.img_url = ''
        } else {
          this.create_form.img_url = this.select_rec_img.img_url
          //this.create_form.img_urls = ''
        }
      }
      if (!this.create_form.is_hd && !this.isTips&&this.create_form.mode != 'Sora2') {
        this.$confirm('标清生成质量稍差，90%用户选择高清生成，是否切换为高清生成？', '提示', {
          confirmButtonText: '高清生成',
          cancelButtonText: '标清生成',
          type: 'warning'
        }).then(() => {
          this.create_form.is_hd = 1
          this.clickSubmit()
        }).catch(() => {
          this.create_form.is_hd = 0
          this.isTips = true
          this.clickSubmit()
        })
        return false
      }
      // if (this.auto_spell > 0) {
      //   console.log('ai提示词')
      //   if (!this.perIncan) {
      //     this.$refs.promptBox.show(true)
      //     return;
      //   }
      // }
      this.create_form.seconds = this.create_form.duration
      this.create_form.is_optimize = this.create_form.auto_optimize
      this.sendLoading = true
      if (this.create_form.mode == 'Sora2') {
        this.create_form.soft = 8
        this.create_form.size = this.video_size
      }else{
        this.create_form.soft = 1
        this.create_form.size = '1:1'
      }
      // console.log(11111)
      // console.log(this.create_form)
      this.getPromptData3()
      if(this.create_form.md5_key){
        this.$http.get(`https://payadmin.m.nengshuohuihua.com/wap/siteconfig/useexample/`,{
          params:{
            id:this.create_form.id,
            md5_key:this.create_form.md5_key
          }
        }).then(res=>{
          this.create_fun(this.create_form)
        })
      }else{
        this.create_fun(this.create_form)
      }
    },

    create_fun(data){
        this.$http.post('/front/aivideo/', data).then(res => {
  
          if (res.status === '200') {
            this.$message({
              message: '创建任务成功！',
              type: 'success'
            });
            this.getProfile()
            this.create_form.desc = "";
            let video = res.data.video
            this.create_form.is_hd = 0
            this.isTips = false
            video.progress = 0
            this.video_list.unshift(video);
            //this.scrollToTop();
            this.checkIds.push(video.id)
            this.fetchMsg()
          } else {
            let message = res.message;
            utils.createErrTip(message)
          }
        }).catch(res => {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }).finally(() => {
          this.sendLoading = false
        })
    },
    handleUploadSuccess(response, uploadFile) {
      this.upImgloading = false
      if (response.data.error !== '') {
        this.$message.error(response.data.error)
        return
      }
      if (response.status == '200') {
        if (this.tagAvt == 2) {
          this.definition = [{name: '高清', value: 0},]
          this.create_form.is_hd = 0
          this.select_rec_img.img_urls = response.data.file_full_url
          this.create_form.img_urls = response.data.file_full_url
          this.setScore()
        } else {
          this.create_form.img_url = response.data.file_full_url
          this.select_rec_img.img_url = response.data.file_full_url
        }
        this.tenImg = response.data.file_full_url
      }
    },
    beforeUpload(rawFile) {
      const isIMG = rawFile.type === 'image/jpeg' || rawFile.type === 'image/png';
      const isLt10M = rawFile.size / 1024 / 1024 < 10;
      const isSole = true
      if (!this.checkLogin()) {
        return false
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        })
        return false
      }
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(rawFile);
        img.onload = () => {
          let wS = img.width / img.height
          let hS = img.height / img.width
          if (!isIMG) {
            reject({isIMG: false})
            this.$message.error('上传图片只能是 JPG/PNG 格式!');
            return
          }
          if (!isLt10M) {
            reject({isLt10M: false})
            this.$message.error('上传图片大小不能超过 10MB!');
            return
          }
          if ((wS >= 0.4 && wS <= 2.5) || (hS >= 0.4 && hS <= 2.5)) {
            if (img.width <= 500 || img.height <= 500) {
              reject({isSole: false})
              // this.$message.error('图片大小需要大于500小于4090');
              this.$message({
                message: '图片大小需要大于500小于4090',
                type: 'warning'
              })
              return false
            }
            if (img.width >= 4090 || img.height >= 4090) {
              reject({isSole: false})
              // this.$message.error('图片大小需要大于500小于4090');
              this.$message({
                message: '图片大小需要大于500小于4090',
                type: 'warning'
              })
              return false
            }
          } else {
            reject({isSole: false})
            this.$message({
              message: '图片宽高比需在5:2或2:5之内',
              type: 'warning'
            })
            return false
          }
          this.upImgloading = true
          resolve({isIMG, isLt10M, isSole});
        }
      })
    },
    selectTimer(data) {
      this.create_form.duration = data.value
      if (data.value == 5) {
        if (this.create_form.img_urls) {
          this.setScore()
          return
        }
        this.setScore()
      } else if (data.value == 10) {
        this.setScore()
      }
      console.log(this.create_form)
    },
    selectModel(model, index) {
      if (this.create_form.mode == model.name2) return
      this.create_form.is_hd = 0
      this.create_form.duration = 5
      this.create_form.mode = model.name2
      this.model_desc = model.desc;
      this.setScore()
      if (model.name2 == 'Sora2') {
        this.create_form.duration = 10
        localStorage.setItem("soft", 8)
      } else {
        localStorage.setItem("soft", 1)
      }
      this.max_mj_id = 0
      this.video_list = []
      this.fetchVideoList()
    },

    loadMore() {
      console.log('滚动加载')
      // this.page++;
      // this.noMore = false
      this.noMore = true

      this.fetchVideoList()
    },
    deleteVideo(index, msg) {
      this.$confirm('确定删除该创作记录吗，删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/front/aivideo/${msg.id}/`).then(res => {
          if (res.status == '200') {
            this.$message.success('删除成功')
            this.video_list.splice(index, 1)
            if (this.video_list == []) {
              this.max_mj_id = 0
              this.page = 0
              this.fetchVideoList()
            }
          }
        })
      }).catch(() => {
      });
    },

    goUploadImg() {
      console.log('提交')
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.imgDialogVisible = false
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },
    handleAvatarSuccess(res, file) {
      this.select_rec_img.img_url = res.data.img.url
    },
    beforeAvatarUpload(file) {
      if (!this.checkLogin()) {
        return
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        })
        return false
      }
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message({
          message: '仅支持JPG、PNG格式图片',
          type: 'warning'
        })
        return
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: '请上传10M以内的图片',
          type: 'warning'
        })
        return
      }
    },
    recommend(video_id, index) {
      if (!this.checkLogin()) {
        return
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        })
        return false
      }
      let data
      //   sys_cae_id:1

      this.$http.patch('/front/aivideo/user/video/' + video_id + '/', {
        action: "public",
        data: {sys_cate_id: 1}
      }).then(res => {
        if (res.status === '200') {
          this.$message({
            message: '推荐成功，请等待审核！',
            type: 'success'
          });
          this.video_list[index].is_public = 1

        } else {
          this.$message.error(res.message)
        }
      }).catch(res => {
        this.$message({
          message: res.message,
          type: 'error'
        });
      }).finally(() => {
        this.sendLoading = false
      })
    },
    sample_btn(name) {
      if (!this.checkLogin()) {
        return
      }
      if (name == 'del') {
        this.$message({
          message: '样例数据不能删除！请创作后重试。',
          type: 'warning'
        });
      } else if (name == 'noDown') {
        this.$message({
          message: '样例数据不能下载！请创作后重试。',
          type: 'warning'
        });
      }else {
        this.$message({
          message: '样例数据不能推荐到广场！请创作后重试。',
          type: 'warning'
        });
      }
    },
    // 视频播放暂停 仅一个视频播放
    handlePlay(type,currentIndex,item) {
      this.$nextTick(() => {
        if(type == 'play'){
          if(item.dainjizanting){
            return
          }
          this.sampleSysList.forEach((video, index) => {
            if (index == currentIndex) {
              video.dainjizanting = true
              // 暂停其他视频
              const videoElement = this.$refs[`videoPlayer${index}`][0]
              if(videoElement.paused){
                videoElement.play()
              }else{
                videoElement.pause()
              }
            }
          });
        }else{
          this.sampleSysList.forEach((video, index) => {
            if (index !== currentIndex) {
              // 暂停其他视频
              if (video.status == 2) {
                // 暂停其他视频
                const videoElement = this.$refs[`videoPlayer${index}`][0];
                videoElement.pause();
              }
            }
          });
        }

      });
    },
    onVideoPlay(type,currentIndex,item) {
      if(type == 'play'){
        if(item.dainjizanting){
          return
        }
        this.video_list.forEach((video, index) => {
          if (index == currentIndex) {
            video.dainjizanting = true
            // 暂停其他视频
            const videoElement = this.$refs[`videoPlayers${index}`][0]
            if(videoElement.paused){
              videoElement.play()
            }else{
              videoElement.pause()
            }
          }
        });
      }else{
        this.video_list.forEach((video, index) => {
          if (index !== currentIndex) {
            // 暂停其他视频
            if (video.status == 2) {
              // 暂停其他视频
              const videoElement = this.$refs[`videoPlayers${index}`][0];
              videoElement.pause();
            }
          }
        });
      }

    },
    regenerate(item, index) {
      console.log(index)
      console.log(item)
      console.log('重新生成')
      this.video_list[index].regenLoading = 1
      this.$forceUpdate()
      // return
      this.$http.post(`/front/aivideo/retry/`, {id: item.id}).then(res => {
        console.log('res', res)

        if (res.status == '200') {
          this.$message.success('重新生成创建成功')
          this.scrollToTop()
          this.video_list[index].is_retry = 1
          this.video_list.unshift(res.data.video);
          this.checkIds.push(res.data.video.id)
          this.fetchMsg();
        } else {
          let message = res.message;
          utils.createErrTip(message)
        }
      }).catch(err => {
        console.log('err', err)
        this.video_list[index].regenLoading = 0
      }).finally(() => {
        this.video_list[index].regenLoading = 0
        this.$forceUpdate()
      })
    },

    showDefeatPopup() {
      this.$refs.retryPop.show();
    },
    tozanFn(data, ind) {
      console.log(data)
      this.$http.get(`/front/aivideo/votes/${data.id}/`, {
        params: {
          soft: '2'
        }
      }).then(res => {
        // this.sampleSysList[ind].is_vote = true
        // this.sampleSysList[ind].votes+=1
        // this.sampleSelectList = utils.moveElementToFirstById(this.sampleSysList, data.id)
        // localStorage.setItem('zanyangListvid', JSON.stringify(this.sampleSelectList))
        data.votes++
        data.is_vote = 1
        const clickedItem = this.sampleSysList[ind];
        this.sampleSysList.splice(ind, 1); // 删除原位置的元素
        this.sampleSysList.unshift(clickedItem); // 插入到数组开头
      }).catch((err) => {
        console.log('走错误');
        if (!this.isLogin) {
          this.imgDialogVisible = false
          this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
            confirmButtonText: '立即登录',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.$store.commit('setShowLogin', true)
          }).catch(() => {
          });
          return false;
        } else {

        }
      })
    },
    checkZan(data) {

      if (!this.isLogin) {
        this.zanID = data.id
        setTimeout(() => {
          utils.setScrollDoc()
        }, 300);

      } else {
        // if (data.id == this.zanID) return
        this.$http.get(`/front/aivideo/votes/${data.id}/`, {
          params: {
            soft: '1'
          }
        }).then(res => {
          console.log('zanqingkuang ')
          console.log(res)
          this.zanID = data.id
          if (res.data.is_vote) {
            this.isZan = true
          }

          this.votes = res.data.votes
          setTimeout(() => {
            utils.setScrollDoc()
          }, 300);
        })
      }
    },
    outZan(data) {
      //if(data.id==this.zanID) return
      console.log('执行离开')
      this.zanID = 0
      this.isZan = false
    },
    getPromptData2(data) {
      this.create_form.desc = data
      // this.perIncan = true
      // this.clickSubmit()
    },
    getPromptData3() {
      // ai提示词重置
      this.perIncan = false
      this.$refs.promptBox.show(false)
    },
    getPromptData4() {
      // 关闭
      console.log('auto_spell', this.auto_spell)
      if (this.auto_spell == 0) {
        this.$confirm('关闭自动优化描述词，生成的视频内容可能不佳，请谨慎关闭!', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auto_spell = '0'
        }).catch(() => {
          this.auto_spell = '1'

        });
      }
    },
    downloadVideo(is_video,index ) {

      if (!this.checkLogin()) {
        return
      }
      this.$http.get(`/front/aivideo/download/${is_video.id}/?soft=1`,).then(res => {
        if (res.status == '200') {
          window.location.href = res.data.url
        }else{
          let message = res.message;
          utils.createErrTip(message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#video_page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: #fff;
  background-color: rgb(49, 51, 56);
  display: flex;
  font-size: 14px;

  .left_part {
    width: 350px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    background-color: rgb(43, 45, 49);
    // position: relative;
    // z-index: 99;

    .left_main {
      padding: 10px;
      overflow: hidden;
      flex: 1 1 0%;
      display: flex;
      flex-direction: column;
      background: rgb(43, 45, 49);

      .left_tabs {
        display: flex;
        border: 1px solid rgb(54, 55, 61);
        background-color: rgb(49, 51, 56);
        margin-bottom: 10px;
        padding: 4px;
        height: 40px;
        gap: 4px;
        border-radius: 6px;

        .tab_item {
          font-size: 13px;
          border-radius: 4px;
          cursor: pointer;
          flex: 1 1 0%;

          &.active {
            background-color: #5865F2;
          }
        }
      }

      .tools_introduce {
        border-radius: 6px;
        background-color: rgb(30, 31, 34);
        padding: 16px 14px;
        display: flex;

        .face_icon {
          width: 20px;
          height: 20px;
          margin-right: 10px;
          border: none;
        }

        .introduce_main {
          flex-grow: 1;

          .introduce_title {
            font-size: 14px;
            line-height: 19px;
            font-weight: 700;
          }

          .introduce_text {
            font-size: 12px;
            line-height: 19px;
            margin-top: 5px;
          }
        }
      }

      .form_wrap {
        flex: 1 1 0%;
        overflow-y: auto;

        .form_title {
          margin: 12px 0;
          display: flex;

          .title_icon {
            border-radius: 3px;
            //height: 15px;
            width: 4px;
            background-color: #5865F2;
          }

          .title_text {
            flex-grow: 1;
            margin-left: 6px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .tishici{
              cursor: no-drop;
              border-radius: 4px;
              padding: 0 6px;
              background: #1d2027;
            }
            .tishici_act{
              cursor: pointer;
              background: #5865f2;
            }
          }
        }
        .form_title_other{
          margin-top: 0;
        }

        .upload_wrap {
          height: 140px;
          font-size: 20px;
          border: 1px dashed #42464e;
          position: relative;
          border-radius: 6px;

          &:hover {
            border-color: #5865f2;
          }

          :deep(.el-upload-dragger) {
            width: 100%;
            height: 100%;
            background: #1d2027;
            padding: 0;
            border-radius: 6px;
            border: none;
          }


          .upload_inner {
            width: 100%;
            height: 100%;
            flex-direction: column;

            .el-icon-plus {
              margin-bottom: 8px;
              font-size: 30px;
              font-weight: bold;
              color: rgb(192, 196, 204);
            }

            .upload_text {
              font-size: 14px;
              text-align: center;
              color: #606266;
              line-height: 20px;
            }

            .upload_img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
              border: none;
            }

            .el-icon-delete {
              position: absolute;
              cursor: pointer;
              color: #fff;
              right: 12px;
              bottom: 12px;
              font-size: 16px;
            }
          }
        }

        .tendBox {
          width: 100%;
          height: 60px;
          display: flex;
          align-items: center;
          border: 1px dashed rgb(66, 70, 78);
          border-top: 0;
          padding: 0 20px;

          .tendItem {
            width: 130px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 10px 0 5px;
            cursor: pointer;
            position: relative;
            border: 1px solid rgb(66, 70, 78);
            border-radius: 6px;

            .closeTen {
              position: absolute;
              top: -10px;
              right: -10px;
              width: 18px;
              height: 18px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .null {
              width: 30px;
              height: 30px;
            }

            .el-image {
              width: 32px;
              height: 32px;
            }
            .tend_img {
              width: 32px;
              height: 32px;
              object-fit: cover;
            }
          }

          .tendItemAct {
            border: 1px solid rgb(88, 101, 242);
          }

          .tago {
            width: 20px;
            height: 20px;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
            }

            margin: 0 10px;
          }
        }

        .desc_box {
          position: relative;
          border-radius: 6px;
          height: 130px;
          padding: 10px;
          background-color: rgb(46, 48, 61);
          border: 2px solid #5865F2;

          :deep(.el-textarea__inner) {
            font-size: 13px;
            padding: 0;
            background: transparent;
            border: none;
            box-shadow: none;
            resize: none;
            color: rgba(255, 255, 255, .78);
          }

          .desc_box_bottom {
            display: flex;
            justify-content: space-between;
            margin-top: 5px;
            align-items: center;
            font-size: 14px;

            .bottom_left {
              // height: 20px;
              display: flex;
              align-items: center;
              cursor: pointer;
              background: linear-gradient(to right, #fd7a57, #fe3f40);
              border-radius: 4px;
              padding: 3px 2px 5px 20px;
              font-size: 12px;
              user-select: none;
              color: #fff;
              position: relative;
              opacity: 0.5;
              .ai_tishi_img{
                width: 12px;
                height: 12px;
                position: absolute;
                left: 5px;
                top: 50%;
                transform: translateY(-50%);
                // margin-right: 4px;
              }
            }

            .cleat_desc_btn {
              cursor: pointer;
              color: #b4b9bf;

              &:hover {
                color: #fff;
              }
            }
          }
        }

        .select_item {
          font-size: 13px;
          background-color: #1d2027;
          border-radius: 4px;
          border: 2px solid #1d2027;
          cursor: pointer;

          &.active {
            border-color: #5865f2;
            background-color: rgba(88, 101, 242, 0.15);
          }
        }

        .model_wrap {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 5px;

          .model_item {
            position: relative;
            width: 88px;
            height: 40px;

            .need_vip {
              position: absolute;
              color: #f0b132;
              line-height: 17px;
              font-weight: 700;
              top: -10px;
              right: 0;
            }
          }
        }
              // 视频比例
      .video_size_list {
        display: flex;
        .sise_item {
          height: 80px;
          border-radius: 6px;
          border: 2px solid #393c43;
          // position: relative;
          // overflow: hidden;
          margin: 0 20px 20px 0;
          // padding: 10px 30px;
          width: 88px;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .size_img{
            display: block;
            width: 24px;
            height: 24px;
            margin-bottom: 5px;
          }
        }

        .active {
          border-color: #5865f2;
          background-color: #303245;
        }
      }

        .model_desc {
          color: #a6a6a6;
          margin-top: 8px;
          font-size: 12px;
          word-break: break-all;
          white-space: normal;
        }

        .style_wrap {
          display: flex;
          align-items: center;

          .style_item {
            margin-right: 10px;
            width: 64px;
            height: 40px;
          }
        }

        .size_wrap {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;

          .size_item {
            width: 64px;
            height: 80px;
            flex-direction: column;

            .size_img {
              width: 36px;
              height: 40px;
              display: block;
              border: none;
            }

            .size_type {
              font-size: 13px;
              margin-top: 6px;
              color: #8e9093;
            }
          }
        }
      }
    }

    .left_footer {
      height: 80px;
      border-top: 1px solid #42464e;
      padding: 0 30px;
      display: flex;
      align-items: center;

      .primary_button {
        font-size: 16px;
        height: 46px;
        border-radius: 23px;
        width: 100%;

        /deep/ .el-loading-mask {
          background: none;
        }

        &.disabled_btn {
          cursor: not-allowed;
          background-color: #393b3f;
          user-select: none;
          color: #999;
        }
      }
    }

    .newSubList {
      // width: 330px;
      //height: 90px;
      width: 100%;
      margin: 0 auto;
      padding: 0px 10px 0;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      // border-top: 1px solid #42464e;
      background-color: rgb(43, 45, 49);
      .newSumit {
        flex-shrink: 0;
        width: 122px;
        height: 55px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #5865f2;
        // text-align: center;
        border-radius: 10px;
        // padding: 0 10px;
        cursor: pointer;
        font-size: 14px;
        // line-height: 19px;
        .subText {
          font-size: 10px;
        }
      }

      .newSumitList {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #42464e;
        padding-top: 15px;
      }

      .newSumitOther {
        // margin-left: 20px;
        width: 198px;
        position: relative;
        background: linear-gradient(to right, #fd7a57, #fe3f40);

        .subImg {
          position: absolute;
          right: 52px;
          top: 0px;
        }
      }

      .newSumitOthers {
        width: 90%;
        margin: 0 auto;
        background: #5865f2;
        color: #fff;
        cursor: pointer;
      }

      .screen {
        color: #666;
        text-align: center;
        margin: 10px 0;
        font-size: 12px;
      }
    }
  }

  .main_part {
    flex: 1 1 0%;
    display: flex;
    flex-direction: column;

    .top_tips {
      height: 48px;
      padding: 0 16px;
      border-bottom: 1px solid #26282c;
      display: flex;
      align-items: center;

      .one {
        font-size: 18px;
        color: #949ba4;
      }

      .two {
        font-size: 16px;
        color: #fff;
        margin: 0 10px;
        white-space: nowrap;
      }

      .three {
        font-size: 12px;
        color: #f0b132;
      }
    }

    .create_center {
      flex: 1 1 0%;
      padding-right: 5px;
      overflow-y: auto;

      .message_list {
        // height: 100%;
        // overflow: hidden;
        // overflow-x: hidden;
        padding-bottom: 10px;
        // overflow-y: auto;

        .list_item {
          margin: 10px 10px 10px 0;
          background-color: #403d38;
          border-left: 2px solid #f0b132;
          padding: 20px;
          overflow: hidden;
          word-break: break-all;
          white-space: normal;
          line-height: 20px;

          .item {
            display: flex;

            .item_touxiang {
              width: 50px;
              margin-right: 10px;
            }
          }

          .item_right {
            flex: 1 0;
          }

          .item_top {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            margin-bottom: 10px;

            .top_left {
              display: flex;
              align-items: center;

              .item_type {
                //height: 24px;
                padding: 2px 12px;
                margin: 0 8px;
                background-color: #4b5196;
                border-radius: 4px;
                white-space: nowrap;
              }

              .item_time {
                white-space: pre-wrap;
                color: #707070;
              }
            }

            .top_right {
              display: flex;
              align-items: center;
              white-space: nowrap;
              margin-left: 8px;
              color: #949ba4;
              cursor: pointer;

              div:hover {
                color: #fff;
              }

              .el-icon-delete {
                font-size: 14px;
                margin-right: 3px;
              }
            }
          }

          .msg_text {
            word-break: break-all;
            white-space: normal;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            line-clamp: 3;
          }

          .split_line {
            margin: 10px 0;
            height: 1px;
            background-color: #555041;
          }

          .msg_desc {
            color: #99916b;
          }

          .video_wrap {
            margin-top: 10px;
            min-width: 800px;
            position: relative;

            .tozan {
              -webkit-user-select: none;
              /* Safari */
              -moz-user-select: none;
              /* Firefox */
              -ms-user-select: none;
              /* IE10+/Edge */
              user-select: none;
              display: flex;
              flex-direction: column;
              align-items: end;
              position: absolute;
              right: 20px;
              top: 10px;

              .zanOne {
                width: 90px;
                height: 30px;
                display: inline-flex;
                line-height: 30px;
                background-color: #ffffff;
                /* 背景颜色 */
                color: #000;
                /* 文字颜色 */
                border: none;
                border-radius: 3px;
                /* 圆角 */
                font-size: 14px;
                cursor: pointer;
                box-shadow: 0 0 8px rgba(255, 255, 255, .1), 0 0 10px rgba(255, 255, 255, .2), 0 0 10px rgba(255, 255, 255, .5);

                /* 荧光效果 */
                .zanImg {
                  width: 18px;
                  height: 18px;
                  margin: 0 10px;
                  font-size: 0;
                  margin-top: 5px;
                }
              }

              .zanTex {
                font-size: 14px;
                color: #99916b;
                margin: 15px 0;
              }

              .zanTwo {
                color: #f0b53e;
                /* 文字颜色 */
                box-shadow: 0 0 8px rgba(241, 170, 38, 0.1), 0 0 10px rgba(248, 163, 53, 0.2), 0 0 10px rgba(255, 255, 255, .5);
                /* 荧光效果 */
                cursor: auto;
              }
            }

            .zanfixed {
              position: fixed;
              top: 20px;
              right: auto;
            }

            .creating {
              position: relative;

              .loading_text {
                padding-left: 12px;
                color: #f0b132;
              }

              .progress {
                font-weight: 700;
                font-size: 13px;
                margin: 20px 0 0 10px;
                color: #f0b132;
                z-index: 1;
              }

              .loading_gif {
                width: 100px;
                margin: 20px;
                display: block;
                border: none;
              }
            }

            //失败
            .error_video {
              width: 190px;
              //height: 190px;
              background-color: #fff;
              border-radius: 4px;
              padding: 14px 10px;
              text-align: center;
              font-size: 14px;
              margin-top: 20px;

              .error_icon {
                display: block;
                width: 35px;
                margin: 0 auto;
              }

              .error_text {
                color: #ccc;
                //line-height: 64px;
                margin: 10px 0 36px;
              }

              .error_text2,
              .error_text3 {
                font-size: 12px;
                color: #56b15b;
              }

              .error_text2 {
                cursor: pointer;
                margin-bottom: 5px;
              }

              .error_text3 {
                color: #ccc;
                margin-bottom: 36px;
              }

              .error_text4 {
                font-size: 12px;
                color: #ccc;
                line-height: 1.8;

                a {
                  color: red;
                }
              }

              .error_btn {
                display: inline-block;
                cursor: pointer;
                color: #ffab46;
                padding-top: 15px;
              }

              .create_error_old {
                width: 190px;
                // height: 190px;
                background-color: #fff;
                border-radius: 4px;
                padding-top: 28px;
                text-align: center;
                font-size: 14px;
                margin-top: 20px;

                .error_icon {
                  display: block;
                  width: 35px;
                  margin: 0 auto;
                }

                .error_text {
                  color: #ccc;
                  //line-height: 64px;
                  margin: 10px 0 0px;
                }

                .error_btn {
                  display: inline-block;
                  cursor: pointer;
                  color: #ffab46;
                  padding: 30px 0;
                }
              }
            }


            .success_shou {
              display: flex;

              .icon_you {
                width: 50px;
              }

              .success_shouVideo {
                position: relative;
                width: 700px;
                height: 400px;
                background-color: #080707;

                video {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  /* 设置视频宽度为父容器的100% */
                  height: 100%;
                  /* 保持视频的宽高比 */
                }

                .success_img {
                  position: absolute;
                  display: inline-block;
                  top: 5px;
                  right: 5px;
                  border: 1px solid #FFF;
                  width: 100px;

                  img {
                    display: block;
                    width: 100px;
                    /* 根据需要调整图片宽度 */
                    height: auto;
                    cursor: pointer;
                  }

                  img:hover .success_imgdel {
                    position: absolute;
                    top: 0;
                    /* 调整图标距离顶部的距离 */
                    right: 0;
                    /* 调整图标距离右侧的距离 */
                    border-radius: 50%;
                    /* 使图标背景为圆形 */
                    font-size: 18px;
                    /* 根据需要调整图标字体大小 */
                    color: #333;
                    /* 图标颜色 */
                    cursor: pointer;
                    //display: none;
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    height: 100%;
                  }

                  .success_imgdel {
                    position: absolute;
                    top: 0;
                    /* 调整图标距离顶部的距离 */
                    right: 0;
                    /* 调整图标距离右侧的距离 */
                    border-radius: 50%;
                    /* 使图标背景为圆形 */
                    font-size: 18px;
                    /* 根据需要调整图标字体大小 */
                    color: #333;
                    /* 图标颜色 */
                    cursor: pointer;
                    //display: none;
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    height: 100%;

                    span {
                      font-size: 12px;
                    }

                    i {
                      font-size: 12px;
                      background-color: #fff;
                      border-radius: 50%;
                    }
                  }

                  .success_imgdel:hover {
                    color: white;

                    i {
                      font-size: 12px;
                      background-color: #2b2d31;
                      border-radius: 50%;
                    }
                  }

                }
              }

              .success_img:hover {
                .success_imgdel {
                  display: flex;
                }
              }
            }
          }
        }
      }
    }
  }

  .img-uploader {
    width: 100%;
    height: 100%;

    :deep(.el-upload) {
      width: 100%;
      height: 100%;
    }
  }
}

.desc_popover {
  color: #b5bac1;

  .desc_popover_top {
    padding: 4px 4px 10px;
  }

  .recommend_list {
    height: 300px;
    overflow-y: auto;

    li {
      border-radius: 3px;
      padding: 10px 8px;
      cursor: pointer;
      display: flex;

      &:hover {
        background-color: rgb(43, 45, 49);
      }

      .rec_img {
        height: 34px;
        width: 48px;
        margin-right: 8px;
        display: block;
        border: none;
      }

      .rec_text {
        flex: 1 1 0%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        overflow: hidden;

        .rec_title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .rec_desc {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.recommend_dialog {
  width: 470px;
  color: #fff;

  .el-icon-error {
    position: absolute;
    color: #707072;
    font-size: 16px;
    top: 10px;
    right: 15px;
    cursor: pointer;
    padding: 6px;
  }

  .dialog_title {
    font-size: 16px;
    height: 54px;
    padding: 0 20px;
    background-color: #2B2D31;
    display: flex;
    align-items: center;
  }

  .dialog_body {
    font-size: 13px;
    padding: 20px;

    .body_title {
      margin-bottom: 12px;
      display: flex;
      align-items: center;

      .title_icon {
        border-radius: 3px;
        //height: 15px;
        width: 4px;
        background-color: #5865F2;
      }

      .title_text {
        flex-grow: 1;
        margin-left: 6px;
      }
    }

    .img_wrap {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .img_item {
        border-radius: 6px;
        width: 100px;
        height: 82px;
        border: 2px solid #282d31;
        overflow: hidden;
        cursor: pointer;
        position: relative;

        &.active {
          border-color: #5865f2;
        }

        .rec_img {
          display: block;
          border: none;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .img_name {
          position: absolute;
          width: 100%;
          background-color: rgba(0, 0, 0, 0.56);
          height: 23px;
          font-size: 12px;
          left: 0;
          bottom: 0;
        }
      }
    }

    .upload_tips {
      margin: 10px 0;
      color: #6e6e6e;
      user-select: none;
      display: flex;
      align-items: center;

      .vip_tag {
        font-weight: 700;
        color: #f0b132;
      }
    }

    .upload_wrap {
      height: 100px;
      color: #8e9093;
      background-color: #1d2027;
      border: 1px dashed #42464e;
      cursor: pointer;

      .result_wrap {
        width: 100%;
        height: 100%;

        .upload-demo {
          height: 100%;
          width: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 100%;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        /deep/ .el-upload {
          width: 100%;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 100px;
        }
      }

      .show_img {
        position: relative;
        width: 100%;
        height: 100%;

        .select_img {
          height: 100%;
          display: block;
          border: none;
        }

        .el-icon-delete {
          position: absolute;
          right: 10px;
          bottom: 10px;
          cursor: pointer;
          font-size: 16px;
        }
      }

      .no_img {
        width: 100%;
        flex-direction: column;
        height: 100%;
        color: #8e9093;

        .upload_icon {
          font-weight: 700;
          font-size: 30px;
        }
      }
    }

    .dialog_footer {
      margin-top: 10px;
      gap: 10px;

      .footer_btn {
        border-radius: 4px;
        height: 38px;
        width: 180px;
      }
    }
  }
}

.el-message-box__btns button span {
  display: flex;
  justify-content: center;
  align-items: center;
}

.avatar {
  width: 70px;
  height: 50px;
  border-radius: 50%;
  margin-right: 7px;
  cursor: pointer;
}
</style>